<div class="chatbot-panel-body" id="chat-scroll">
    <div #scrollhere>
        <ul class='chatbot'>
            <message-item *ngFor='let msg of messages;let i = index' [message]='msg'
            [inputResponseObj]='emitResponseObj' [widget]='response'></message-item>
        </ul>
    </div>
</div>